import { useState } from "react";
import { PillTabs } from "@/shared/components/PillTabs";
import { InvitationsTab } from "./InvitationsTab";
import { PhysiciansTab } from "./PhysiciansTab";

type TabId = "invitations" | "physicians";

const TABS: { id: TabId; label: string }[] = [
  { id: "invitations", label: "Invitations" },
  { id: "physicians", label: "Physicians" },
];

export function PhysiciansView() {
  const [tab, setTab] = useState<TabId>("invitations");

  return (
    <div className="min-h-full bg-[#F7F7F7] px-4 py-4 lg:px-6 lg:py-5">
      <div className="rounded-3xl border border-[#E5E7EB] bg-white p-5 shadow-sm">
        <div className="mb-5 flex justify-center">
          <PillTabs tabs={TABS} active={tab} onChange={setTab} label="Physician management view" />
        </div>
        {/* Conditional render remounts each tab on switch, so it refetches —
            a physician who just accepted shows up without a page reload. */}
        {tab === "invitations" ? <InvitationsTab /> : <PhysiciansTab />}
      </div>
    </div>
  );
}
